import { render, staticRenderFns } from "./InvoiceOrderHeader.vue?vue&type=template&id=7b3e9816&scoped=true&"
import script from "./InvoiceOrderHeader.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOrderHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceOrderHeader.vue?vue&type=style&index=0&id=7b3e9816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3e9816",
  null
  
)

export default component.exports